import { useState } from "react";
import axios from "axios";
import { Mail, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/config";
import { useCountry } from "@/components/contexts/CountryContext";

/**
 * Collect an address for the trending digest.
 *
 * Storage only. Sending needs SMTP credentials that are not configured, so this
 * builds the list now and the send can be switched on later without another UI change.
 */
export const DigestSignup = () => {
  const { country } = useCountry();
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setState("sending");
    try {
      await axios.post(`${API}/subscribe`, { email: email.trim(), country: country.code });
      setState("done");
      toast.success("Subscribed to the trending digest");
    } catch (err) {
      setState("idle");
      toast.error(err.response?.data?.detail || "Could not subscribe");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-center justify-center gap-2 p-4 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-sm text-emerald-400">
        <Check className="w-4 h-4" /> You are on the list.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="p-4 rounded-xl bg-white/[0.03] border border-white/10">
      <div className="flex items-center gap-2 mb-2">
        <Mail className="w-4 h-4 text-orange-500" />
        <h3 className="font-heading text-sm font-bold">Trending digest</h3>
      </div>
      <p className="text-xs text-white/50 mb-3">
        The week's biggest videos in {country.name}, in your inbox.
      </p>
      <div className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 px-3 py-2 rounded-lg bg-white/5 border border-white/10 focus:border-orange-500/60 outline-none text-xs transition-colors"
          data-testid="digest-email"
        />
        <button
          type="submit"
          disabled={state === "sending"}
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-black text-xs font-bold transition-colors"
        >
          {state === "sending" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Subscribe"}
        </button>
      </div>
    </form>
  );
};
